module.exports = __webpack_public_path__ + "img/oddvega-logo-new-curve.1fbf1999.png";